// ======================================================
// Updated by: Halimunnisa
// Feature: Lead To Project Workflow Separation
// Purpose: Exposed existing post-customer-acceptance workflow tabs inside Projects module.
// ======================================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LEAD_STAGES } from '@/constants/globalConstants';

export const PipelineTabs = ({ currentTab, onTabChange, stages, allLabel = 'All Leads', hideAll = false }) => {
  const tabs = stages || LEAD_STAGES.filter(s => s.key !== 'new' && s.key !== 'assigned');
  const renderedTabs = hideAll ? [...tabs] : [{ key: 'all', label: allLabel }, ...tabs];

  return (
    <div className="w-full bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100/50 overflow-hidden mb-2">
      <div className="flex items-center gap-8 overflow-x-auto px-6 pt-4 border-b border-slate-200 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-thumb]:bg-slate-200 [&::-webkit-scrollbar-thumb]:rounded-full">
        {renderedTabs.map((stage) => {
          const isActive = currentTab === stage.key;
          
          return (
            <button
              key={stage.key}
              type="button"
              onClick={() => {
                if (onTabChange) {
                  onTabChange(stage.key);
                }
              }}
              className={`flex items-center gap-2.5 pb-3 px-1 border-b-2 text-sm font-medium transition-colors whitespace-nowrap outline-none group
                ${isActive ? 'border-[#1e3a8a] text-[#1e3a8a]' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`}
            >
              <span>{stage.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
